//
//
//
//
//
//
//

import common from '@/assets/js/Common'
export default {
    name: 'App',
    data(){
        return {
            transitionName: 'slide-left'
        }
    },
    watch:{
        '$route':function(to,from){
        }
    },
    methods: {

        initBrowserQuery(){

            // 进入页面时，带入的referid 推荐人
            const referid = this.$route.query.referid || '';
            referid && localStorage.setItem("referid",referid);

            // 进入页面时，带入的callback  回调页面，
            // 某些特殊操作需要返回到上次操作位置
            const callback = this.$route.query.callback || '';
            callback && localStorage.setItem("callback",callback);
            console.log('app page run only once');

        },

    },
    beforeMount(){
        this.initBrowserQuery();

    },

}



// WEBPACK FOOTER //
// ./src/App.vue